import React from 'react';

import InputField from '../fields/InputField';

function DateFilter({ label, value, onChange, className = '' }) {
  return (
    <InputField
      type="date"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        inputLabel: { shrink: true },
      }}
      className={className}
    />
  );
}

export default DateFilter;
